
import { JsonObject, JsonProperty } from 'json2typescript';
import { CaseWrite } from '../cases/case';
import { CaseClientLite } from '../cases/caseClient';
import { CaseOpponentLite } from '../cases/caseOpponent';
import { Circle } from '../courts/circle';
import { Court } from '../courts/court';
import { LawSuit } from './lawSuit';
import { LawyerSession } from './lawyerSession';
import { PostponeCloseCause } from './postponeCloseCause';
import { SessionNote } from './sessionNote';

@JsonObject('CaseSessionBase')
export class CaseSessionBase {

    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('case_id', Number, true)
    caseId: number = undefined;

    @JsonProperty('sequence', Number, true)
    sequence: number = undefined;

    @JsonProperty('created_date', String, true)
    createdDate = null;

    @JsonProperty('updated_date', String, true)
    updatedDate: string = null;

    @JsonProperty('session_date', String, true)
    sessionDate = null;

    @JsonProperty('postpone_reason', String, true)
    postponeReason = null;

    @JsonProperty('lawyers', [LawyerSession], true)
    lawyers: LawyerSession[] = null;

    @JsonProperty('suits', [LawSuit], true)
    lawsuits: LawSuit[] = null;

    @JsonProperty('days_left', Number, true)
    daysLeft: number = undefined;

    @JsonProperty('dl', String, true)
    deadline: string = null;

    deadlineDays: string = null;

    setDeadline() {
        this.deadline = `${this.deadlineDays} 00:00:00`;
    }

    setDeadlineDays() {
        this.deadlineDays = this.deadline ? this.deadline.split(' ')[0] : null;
    }

    get deadlineString() {
        return this.deadline ? this.deadline.split(' ')[0] : null;
    }

    get getLawyersInitials() {
        return this.lawyers.map(l => l.lawyer.initials).join(', ');
    }

    get getLawyers() {
        return this.lawyers.map(l => l.lawyer.name).join(', ');
    }

    get getLawyersAr() {
        return this.lawyers.map(l => l.lawyer.nameAr).join(', ');
    }

    removeLawsuit(ls: LawSuit) {
        this.lawsuits = this.lawsuits.filter(l => l.claim !== ls.claim);
    }

    addLawsuit(year, num) {
        const ls = new LawSuit();
        ls.year = year;
        ls.number = num;
        this.lawsuits.push(ls);
    }

    //It is only used in create new session from file case session page
    file: CaseWrite = null;
}

@JsonObject('CaseSession')
export class CaseSession extends CaseSessionBase {
    @JsonProperty('file_num', String, true)
    fileNum: string = null;

    @JsonProperty('case_id', Number, true)
    caseId: number = undefined;

    @JsonProperty('note', String, true)
    note: String = null;

    @JsonProperty('cause', PostponeCloseCause, true)
    cause: PostponeCloseCause = null;

    @JsonProperty('court', Court, true)
    court: Court = null;

    @JsonProperty('circle', Circle, true)
    circle: Circle = null;

    @JsonProperty('clients', [CaseClientLite], true)
    clients: CaseClientLite[] = null;

    @JsonProperty('opponents', [CaseOpponentLite], true)
    opponents: CaseOpponentLite[] = null;

    @JsonProperty('last_session_date', String, true)
    lastSessionDate: string = null;

    @JsonProperty('added_by', String, true)
    addedBy: string = null;

    // @JsonProperty('case_lawyers', [CaseLawyer])
    // fileLawyer: CaseLawyer[] = null;

    get getCourt() {
        return this.court ? this.court.name : '';
    }

    get getCourtAr() {
        return this.court ? this.court.nameAr : '';
    }

    get getCircle() {
        return this.circle?.name ? this.circle.name : '';
    }
    get getCircleAr() {
        return this.circle?.nameAr ? this.circle.nameAr : '';
    }

    get getCause() {
        return this.cause?.cause ? this.cause.cause : '';
    }

    get getCauseAr() {
        return this.cause?.causeAr ? this.cause.causeAr : '';
    }

    get getNote() {
        return this.note ?? '';
    }
    get getNoteAr() {
        return this.note ?? '';
    }

    get getLawyersNameAr() {
        return this.lawyers.map(l => l.lawyer.nameAr).join(', ');
    }

    get getLawyersInitials() {
        return this.lawyers.map(l => l.lawyer.initials).join(', ');
    }

    get getLawsuits() {
        return this.lawsuits.length ? this.lawsuits.map(l => l.claim).join(', ') : '—';
    }

    get courtCircle() {
        return `${this.getCourt} - ${this.getCircle}`;
    }

    get fileInfo() {
        return
    }
}

@JsonObject('CaseSessionWrite')
export class CaseSessionWrite extends CaseSessionBase {
    @JsonProperty('note', String, true)
    note: String = undefined;

    @JsonProperty('court_id', Number, true)
    courtId: number = undefined;

    @JsonProperty('circle_id', Number, true)
    circleId: number = undefined;

    @JsonProperty('cause_id', Number, true)
    causeId: number = undefined;

    @JsonProperty('case_id', Number, true)
    caseId: number = undefined;

    init() {
        this.lawsuits = [];
        this.lawyers = [];
    }
}
